import {
  FETCH_RI_BY_SCENARIO_ID,
  FETCH_RI_BY_SCENARIO_ID_SUCCESS,
  FETCH_RI_BY_SCENARIO_ID_FAIL,
  RISK_INDICATORS_RESET,
  PUT_RI_BY_SCENARIO_ID,
  PUT_RI_BY_SCENARIO_ID_SUCCESS,
  PUT_RI_BY_SCENARIO_ID_FAIL,
  FETCH_RI_LIST_BY_SCENARIO_ID,
  FETCH_RI_LIST_BY_SCENARIO_ID_SUCCESS,
  FETCH_RI_LIST_BY_SCENARIO_ID_FAIL
} from '../../actions/trm/riskIndicators';

export const initialState = {
  isLoading: false,
  error: null,
  riskIndicator: null,
  isSaved: false,
  list: [],
  isLoadingList: false
};

function riskIndicators(state = initialState, action) {
  switch (action.type) {
    case FETCH_RI_LIST_BY_SCENARIO_ID:
      return {
        ...state,
        list: [],
        isLoadingList: true,
        riskIndicator: null,
        error: null,
        isSaved: false
      };
    case FETCH_RI_LIST_BY_SCENARIO_ID_SUCCESS:
      return {
        ...state,
        isLoadingList: false,
        list: action.payload,
        error: null
      };
    case FETCH_RI_LIST_BY_SCENARIO_ID_FAIL:
      return {
        ...state,
        isLoadingList: false,
        list: [],
        error: { ...action.payload }
      };
    case FETCH_RI_BY_SCENARIO_ID:
      return {
        ...state,
        isLoading: true,
        riskIndicator: null,
        error: null,
        isSaved: false
      };
    case FETCH_RI_BY_SCENARIO_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        riskIndicator: action.payload,
        error: null
      };
    case FETCH_RI_BY_SCENARIO_ID_FAIL:
      return {
        ...state,
        isLoading: false,
        riskIndicator: null,
        error: { ...action.payload }
      };
    case PUT_RI_BY_SCENARIO_ID:
      return {
        ...state,
        isLoadingList: true,
        isSaved: false,
        error: null
      };
    case PUT_RI_BY_SCENARIO_ID_SUCCESS:
      return {
        ...state,
        isLoadingList: false,
        isSaved: true,
        error: null
      };
    case PUT_RI_BY_SCENARIO_ID_FAIL:
      return {
        ...state,
        isLoadingList: false,
        isSaved: false,
        error: action.payload
      };
    case RISK_INDICATORS_RESET:
      return { ...initialState };
    default:
      return state;
  }
}

export default riskIndicators;
